import Container from 'react-bootstrap/Container';
import Carousel from 'react-bootstrap/Carousel';
// import slides from './SlideData.json'
import { processFlowArray } from "../assets/ProcessFlowArray";
import "./ProcessFlow.css";

export function ProcessFlow() {
  return (
    <section id='processflow' className='block processflow-block'>
      <Container fluid>
        <div className='title-holder'>
          <h2 className='text-center text-primary'>---Production Process---</h2>
        </div>
        <Carousel controls={true}> {
          processFlowArray.map(flow => {
            return (
              <Carousel.Item key={flow.id}>
                <div className='subtitle text-center'><h3>{flow.description}</h3></div>
                <img src={flow.image} className='d-block border-1' alt={flow.id} />
                {/* <img src={flow.image} className='d-block' style={{ height: '60vh' }} alt={flow.id} /> */}
                <Carousel.Caption>
                  <blockquote>
                    {/* <p><h3>{flow.text}</h3></p> */}
                    <cite>
                      <span className='title'><h3>{flow.title}</h3></span>
                      {/* <span className='description'><h4>{flow.description}</h4></span> */}
                    </cite>
                  </blockquote>
                </Carousel.Caption>
              </Carousel.Item>
            );
          })
        } </Carousel>
      </Container>
    </section>
  );
}

export default ProcessFlow;